module.exports = __webpack_public_path__ + "static/media/ic_user.1dbb9dbc.png";